import { render, staticRenderFns } from "./SideDialogDublicateWork.vue?vue&type=template&id=70a37226&scoped=true&"
import script from "./SideDialogDublicateWork.vue?vue&type=script&lang=js&"
export * from "./SideDialogDublicateWork.vue?vue&type=script&lang=js&"
import style0 from "./SideDialogDublicateWork.vue?vue&type=style&index=0&id=70a37226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a37226",
  null
  
)

component.options.__file = "SideDialogDublicateWork.vue"
export default component.exports